<template>
  <!-- 个人中心数据分析页面 -->
  <div class="right">
    <el-main>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="基础数据" name="first">
          <el-row>
            <el-col>
              <span class="tips"
                >本页根据昨日数据计算，粉丝管理页根据当月数据计算，两者不一致</span
              > </el-col
            ><br /><br />
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <ul>
                  <li>昨日关键指标</li>
                </ul>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="ites grid-content bg-purple-dark">
                <div class="ite">
                  <div class="ite-title">
                    <span>推荐量</span>&nbsp;&nbsp;
                    <el-tooltip
                      content="昨日推荐数"
                      placement="bottom"
                      effect="light"
                    >
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                    <p class="c666">
                      {{ BaseData.recommend_num }}
                    </p>
                    <div class="c666">日：0</div>
                  </div>
                </div>

                <div class="ite">
                  <div class="ite-title">
                    <span>阅读量</span>&nbsp;&nbsp;
                    <el-tooltip
                      content="昨日阅读数"
                      placement="bottom"
                      effect="light"
                    >
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                    <p class="c666">
                      {{ BaseData.pv_num }}
                    </p>
                    <div class="c666">日：0</div>
                  </div>
                </div>

                <div class="ite">
                  <div class="ite-title">
                    <span>阅读完成率</span>&nbsp;&nbsp;
                    <el-tooltip
                      content="仅针对手机App"
                      placement="bottom"
                      effect="light"
                    >
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                    <p class="c666">
                      {{ BaseData.completion_num }}
                    </p>
                    <div class="c666">日：0</div>
                  </div>
                </div>

                <div class="ite">
                  <div class="ite-title">
                    <span>评论量</span>&nbsp;&nbsp;
                    <el-tooltip
                      content="昨日评论数"
                      placement="bottom"
                      effect="light"
                    >
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                    <p class="c666">
                      {{ BaseData.comment_num }}
                    </p>
                    <div class="c666">日：0</div>
                  </div>
                </div>
              </div>

              <div class="ites grid-content bg-purple-dark">
                <div class="ite">
                  <div class="ite-title">
                    <span>点赞量</span>&nbsp;&nbsp;
                    <el-tooltip
                      content="昨日点赞数"
                      placement="bottom"
                      effect="light"
                    >
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                    <p class="c666">
                      {{ BaseData.praise_num }}
                    </p>
                    <div class="c666">日：0</div>
                  </div>
                </div>

                <div class="ite">
                  <div class="ite-title">
                    <span>收藏量</span>&nbsp;&nbsp;
                    <el-tooltip
                      content="昨日收藏数"
                      placement="bottom"
                      effect="light"
                    >
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                    <p class="c666">
                      {{ BaseData.collect_num }}
                    </p>
                    <div class="c666">日：0</div>
                  </div>
                </div>

                <div class="ite">
                  <div class="ite-title">
                    <span>分享量</span>&nbsp;&nbsp;
                    <el-tooltip
                      content="昨日分享数"
                      placement="bottom"
                      effect="light"
                    >
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                    <p class="c666">
                      {{ BaseData.transmit_num }}
                    </p>
                    <div class="c666">日：0</div>
                  </div>
                </div>
              </div>
            </el-col>

            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <ul class="rqxz">
                  <li>日期选择</li>
                  <li @click="changeDay(7)" class="active">
                    <a href="javascript:;">7日</a>
                  </li>
                  <li @click="changeDay(14)">
                    <a href="javascript:;">14日</a>
                  </li>
                  <li @click="changeDay(30)">
                    <a href="javascript:;">30日</a>
                  </li>
                </ul>
                <div id="myChart" style="width: 100%;height: 400px;"></div>
              </div>

              <br /><br />
              <el-table
                :data="tableData"
                style="width: 97%;padding-left:3rem;"
                :row-class-name="tableRowClassName"
              >
                <el-table-column prop="date" label="时间"> </el-table-column>
                <el-table-column prop="recommend_num" label="推荐量">
                </el-table-column>
                <el-table-column prop="pv_num" label="阅读量">
                </el-table-column>
                <el-table-column prop="comment_num" label="评论量">
                </el-table-column>
                <el-table-column prop="praise_num" label="点赞量">
                </el-table-column>
                <el-table-column prop="collect_num" label="收藏量">
                </el-table-column>
                <el-table-column prop="transmit_num" label="分享量">
                </el-table-column>
              </el-table>
            </el-col>
            <br /><br /><br /><br />
            <el-col :span="24"> </el-col>
          </el-row>
        </el-tab-pane>
        <!-- <el-tab-pane label="粉丝画像" name="second">粉丝画像</el-tab-pane> -->
      </el-tabs>
    </el-main>
  </div>
</template>

<script>
// //基础数据
// import { dataAnyCotent } from '@/request/api';
// //表格数据
// import { dataAnyCotentList } from '@/request/api';
// //曲线如数据
// import { dataAnyCotentLine } from '@/request/api';
import Axios from "axios";
export default {
  metaInfo() {
    return {
      title: "数据分析",
      meta: [
        {
          name: "keywords",
          content:
            "驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。",
        },
        {
          name: "description",
          content:
            " 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网",
        },
      ],
    };
  },
  name: "dataAnyCotent",
  data() {
    return {
      msg: "cdn形式",
      activeName: "first",
      BaseData: [],
      type: 0,
      options: {
        title: {
          text: "趋势图",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["推荐", "阅读", "评论", "点赞", "转发", "收藏"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["20190603", "周二", "周三", "周四", "周五", "周六", "周日"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "推荐",
            type: "line",
            stack: "总量",
            data: [],
          },
          {
            name: "阅读",
            type: "line",
            stack: "总量",
            data: [220, 182, 191, 234, 290, 330, 310],
          },
          {
            name: "评论",
            type: "line",
            stack: "总量",
            data: [150, 232, 201, 154, 190, 330, 410],
          },
          {
            name: "点赞",
            type: "line",
            stack: "总量",
            data: [320, 332, 301, 334, 390, 330, 320],
          },
          {
            name: "转发",
            type: "line",
            stack: "总量",
            data: [820, 932, 901, 934, 1290, 1330, 1320],
          },
          {
            name: "收藏",
            type: "line",
            stack: "总量",
            data: [820, 932, 901, 934, 1290, 1330, 1320],
          },
        ],
      },

      //options:[],
      tableData: [],
    };
  },
  methods: {
    handleClick(tab, event) {
      ////console.log(tab, event);
    },
    //获取基础数据
    GetBaseData: function() {
      //webCommentOneList
      Axios({
        method: "post",
        url: "https://researchadmin.qudong.com/api/task_data/index",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          //type: this.type,
        },
      }).then((res) => {
        ////console.log(res);
        this.BaseData = res.data.data;
        ////console.log("======================");
        ////console.log(this.BaseData);
      });
      // dataAnyCotent({type:this.type}).then(res=>{

      //   this.BaseData= res.data;
      //   ////console.log("======================")
      //   ////console.log(this.BaseData)
      // }).catch(res=>{
      //   ////console.log("文章列表获取失败GetBaseData");
      // })
    },

    //获取表格数据
    GetBaseDataList: function() {
      //webCommentOneList
      Axios({
        method: "post",
        url: "https://researchadmin.qudong.com/api/task_data/index_list",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          //type: this.type,
          //day: this.day,
        },
      }).then((res) => {
        ////console.log(res);
        this.tableData = res.data.data.data;
        ////console.log("======================");
        ////console.log(this.tableData);
      });
      // dataAnyCotentList({type:this.type}).then(res=>{
      //   this.tableData = res.data.data;
      //   ////console.log("=222222222222222222222222222222")
      //   ////console.log(this.tableData)
      // }).catch(res=>{
      //   ////console.log("文章列表获取失败");
      // })
    },
    //修改数据图的天数
    changeDay: function(day) {
      this.day = day;
      this.GetBaseDataLine();
    },
    //获取曲线图数据
    GetBaseDataLine: function() {
      ////console.log(this.day);
      //webCommentOneList
      Axios({
        method: "post",
        url: "https://researchadmin.qudong.com/api/task_data/index_line",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          //type: this.type,
          day: this.day,
        },
      }).then((res) => {
        ////console.log(res);
        this.options.xAxis.data = res.data.date;
        ////console.log(res.data.data);
        this.options.series[0].data = res.data.data.tuijian;
        this.options.series[1].data = res.data.data.yuedu;
        this.options.series[2].data = res.data.data.pinglun;
        this.options.series[3].data = res.data.data.dianzan;
        this.options.series[4].data = res.data.data.zhuanfa;
        this.options.series[5].data = res.data.data.shoucang;
        ////console.log(this.options.series[0].data);
      });
    },
    tableRowClassName({ row, rowIndex }) {
      ////console.log(row, rowIndex);
      if (row.jingFen < 0) {
      }
    },
    init: function(e) {
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption(this.options, true);
    },
  },
  watch: {
    //观察option的变化
    options: {
      handler(newVal, oldVal) {
        if (this.myChart) {
          if (newVal) {
            this.myChart.setOption(newVal);
          } else {
            this.myChart.setOption(oldVal);
          }
        } else {
          this.init();
        }
      },
      deep: true, //对象内部属性的监听，关键。
    },
  },
  created() {
    this.GetBaseDataLine();
    this.GetBaseData();
    this.GetBaseDataList();
  },
  mounted() {
    ////console.log("数据挂载");
    this.init();
  },
};
</script>

<style scoped>
.right {
  width: 980px;
  background: #fff;
}
body > .el-container {
  margin-bottom: 40px;
}

.el-container .el-container {
  width: 80%;
  margin: 0 auto;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #fff;
  position: relative;
}

.ite {
  width: 24%;
  border-right: 1px solid #eee;
  display: inline-block;
}

.ite:last-child {
  border: none;
}

.ites {
  padding: 2rem 0;
  border-bottom: 1px solid #eee;
}

.ite .ite-title {
  width: 100%;
  color: #333;
  text-align: center;
}

.ite .ite-title p {
  font-size: 2em;
  font-weight: bold;
}

.el-table div {
  text-align: center;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.rqxz li {
  float: left;
  margin-right: 20px;
}
.rqxz li a {
  color: #409eff;
}
.tips {
  font-size: 15px;
  color: #f83a3a;
}
.rqxz .active {
  color: #f83a3a;
}
.el-input__inner,
.el-button,
.el-upload--picture-card {
  border-radius: 0px;
}
.ite-title span {
  font-size: 14px;
  color: #666;
}
.c666 {
  color: #666;
}
.rqxz {
  display: table;
  text-align: center;
  margin: 60px auto !important;
  overflow: hidden;
}
.bg-purple-dark ul li {
  font-size: 16px;
  font-weight: 700;
}
#ite .ite-title p,
.ite .ite-title p {
  font-size: 3em !important;
}
</style>